import React, {FC} from 'react';
import {useApp} from '@app';
import {Support, SupportAnonymousRedirect, SupportFaqsRedirect} from '../routes.components';

/**
 * `/faqs` and `/support` are the only paths served by a different component per session state, so
 * they cannot be registered under `RequireGuest` / `RequireAuth`: both guards live in the same
 * `useRoutes` tree, the first matching branch wins, and the losing one would redirect the visitor
 * away (to `Path.HOME`) instead of to its counterpart. They are registered once each, outside both
 * guards, and pick their component here.
 */
const FaqsEntry: FC = () => {
  const {authorization} = useApp();

  return authorization ? <SupportFaqsRedirect /> : <Support />;
};

const SupportEntry: FC = () => {
  const {authorization} = useApp();

  return authorization ? <Support /> : <SupportAnonymousRedirect />;
};

export {FaqsEntry, SupportEntry};
